var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',{staticClass:"alert alert-info"},[_vm._v(" "+_vm._s(_vm.$t("salesChannelManagementApp.loadIntegration"))+" ")]),_c(_setup.Loader)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }